import React from 'react';
import { Card, CardHeader, CardBody, CardFooter } from '../ui/Card';
import { Button } from '../ui/Button';
import { CalendarIcon, UsersIcon, StarIcon, DollarSignIcon } from 'lucide-react';
export function SignatureExperiences() {
  const experiences = [{
    title: 'Core Retreat',
    description: 'Perfect for team bonding and strategic planning in a relaxed setting.',
    nights: '3-4 nights',
    activities: 'Single activity',
    price: '$300-$500/night resorts',
    image: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    title: 'Incentive Sprints',
    description: 'Reward top performers with unforgettable experiences that drive motivation.',
    nights: '3-5 nights',
    activities: '3-5 activities',
    price: '$500-$1,000/night',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    title: 'Ultra Brand Launch',
    description: 'Create buzz-worthy product launches and immersive brand experiences.',
    nights: '3-5 nights',
    activities: 'Multiple activations',
    price: '$500+ resorts',
    image: 'https://images.unsplash.com/photo-1531058020387-3be344556be6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }];
  return <section className="py-16 bg-white" data-id="element-211">
      <div className="container mx-auto px-4 md:px-6" data-id="element-212">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-4" data-id="element-214">
            Signature Experiences
          </h2>
          <p className="text-lg text-[#374047]/80" data-id="element-215">
            Tailored packages designed to meet your specific business objectives
            and budget.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-216">
          {experiences.map((exp, index) => <Card key={index} className="h-full overflow-hidden transform hover:-translate-y-2 transition-transform duration-300" data-id="element-217">
              <div className="h-48 overflow-hidden" data-id="element-218">
                <img src={exp.image} alt={exp.title} className="w-full h-full object-cover" data-id="element-219" />
              </div>
              <CardHeader data-id="element-220">
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-221">
                  {exp.title}
                </h3>
              </CardHeader>
              <CardBody data-id="element-222">
                <p className="text-[#374047]/80 mb-4" data-id="element-223">{exp.description}</p>
                <div className="space-y-2" data-id="element-224">
                  <div className="flex items-center" data-id="element-225">
                    <CalendarIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-226" />
                    <span className="text-sm" data-id="element-227">{exp.nights}</span>
                  </div>
                  <div className="flex items-center" data-id="element-228">
                    <StarIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-229" />
                    <span className="text-sm" data-id="element-230">{exp.activities}</span>
                  </div>
                  <div className="flex items-center" data-id="element-231">
                    <DollarSignIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-232" />
                    <span className="text-sm" data-id="element-233">{exp.price}</span>
                  </div>
                </div>
              </CardBody>
              <CardFooter className="justify-center" data-id="element-234">
                <Button variant="outline" to="/packages" data-id="element-235">
                  Learn More
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}